module.exports = __webpack_public_path__ + "img/requestapprvd.8694cd3a.svg";